import React, { Fragment } from "react";
import "./styles.scss";

interface IPageData {
  onPageChanged(pageNumber: number): void;
  pInfo: PageInfor;
}

interface PageInfor {
  totalPages: number;
  page: number;
}

const Pagination = (props: IPageData) => {
  const pageClick = (page: number) => {
    props.onPageChanged && props.onPageChanged(page);
  };

  const getPages = (page: number): number[] => {
    let n: number[] = [];
    if (page <= 3) {
      if (props.pInfo.totalPages < 6) {
        for (let i = 1; i <= props.pInfo.totalPages; i++) {
          n.push(i);
        }
      } else {
        for (let i = 1; i < 6; i++) {
          n.push(i);
        }
      }
    } else if (page > props.pInfo.totalPages - 3) {
      for (
        let i = props.pInfo.totalPages - 4;
        i <= props.pInfo.totalPages;
        i++
      ) {
        i > 0 && n.push(i);
      }
    } else {
      for (let i = -2; i < 3; i++) {
        n.push(page + i);
      }
    }
    return n;
  };

  return (
    <nav
      aria-label="Page navigation"
      className={props.pInfo.totalPages < 2 ? "d-none" : ""}
    >
      <ul className="pagination justify-content-center py-3">
        {props.pInfo.page >= 1 ? (
          <li className="page-item ">
            <label
              className="pagination-arrow-active text-center"
              onClick={() => pageClick(props.pInfo.page - 1)}
            >
              <span className="d-none d-md-inline">Prev</span>
            </label>
          </li>
        ) : (
          <li className="page-item ">
            <label className="pagination-arrow-inactive text-center">
              <span className="d-none d-md-inline">Prev</span>
            </label>
          </li>
        )}

        {props.pInfo.page - 2 > 0 && props.pInfo.totalPages > 5 && (
          <Fragment>
            <button
              className="pagination-button-inactive"
              onClick={() => pageClick(0)}
            >
              1
            </button>
            <span className="px-2">...</span>
          </Fragment>
        )}

        {getPages(props.pInfo.page + 1).map((page: any, index: number) => {
          return (
            <li className="page-item " key={index}>
              {props.pInfo.page === page - 1 ? (
                <button className="pagination-button">{page}</button>
              ) : (
                <button
                  className="pagination-button-inactive"
                  onClick={() => pageClick(page - 1)}
                >
                  {page}
                </button>
              )}
            </li>
          );
        })}
        {props.pInfo.page + 3 < props.pInfo.totalPages &&
          props.pInfo.totalPages > 5 && (
            <Fragment>
              <span className="px-2">...</span>
              <button
                className="pagination-button-inactive"
                onClick={() => pageClick(props.pInfo.totalPages - 1)}
              >
                {props.pInfo.totalPages}
              </button>
            </Fragment>
          )}

        {props.pInfo.page + 1 < props.pInfo.totalPages ? (
          <li className="page-item ">
            <label
              className="pagination-arrow-active text-right text-center"
              onClick={() => pageClick(props.pInfo.page + 1)}
            >
              {" "}
              <span className="d-none d-md-inline">Next</span>
            </label>
          </li>
        ) : (
          <li className="page-item ">
            <label className="pagination-arrow-inactive text-right text-center">
              <span className="d-none d-md-inline">Next</span>
            </label>
          </li>
        )}
      </ul>
    </nav>
  );
};

export default Pagination;
